import { render, staticRenderFns } from "./PerAccount.vue?vue&type=template&id=2052aa58&"
import script from "./PerAccount.vue?vue&type=script&lang=js&"
export * from "./PerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports